import styled from 'styled-components';

export const OffersPageStyled = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--space-4);
    max-width: 950px;
    margin: 0 auto;
    padding-bottom: var(--space-6);

    .page-header {
        display: flex;
        flex-direction: column;
        gap: var(--space-1);
        margin-bottom: var(--space-2);
    }

    .page-title {
        margin: 0;
        font-size: var(--font-size-h3);
        font-weight: 600;
        line-height: 1.25;
        color: var(--color-white-95);
    }

    .page-desc {
        margin: 0;
        font-size: var(--font-size-md);
        color: var(--text-color-secondary);
    }

    .offers-empty {
        margin: 0;
        font-size: var(--font-size-md);
        line-height: 1.5;
        color: var(--text-color-secondary);
    }
`;

export const OffersContainerStyled = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--space-4);
`;
